import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    TextField,
    Box,
    TableContainer
} from "@mui/material";
import React, { useState } from "react";

export default function MPStainlessSteelTempTable({ rows, onSearchChange, searchValue: searchValueProp }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchValue, setSearchValue] = useState(searchValueProp ?? "");

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
        if (onSearchChange) onSearchChange(value);
    };

    const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Paper
            sx={{
                width: "100%",
                maxWidth: "100%",
                p: 2,
                borderRadius: 2,
                overflow: "hidden",
            }}
        >
            <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", borderRadius: 4 }}>
                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Procurar..."
                    value={searchValue}
                    onChange={handleSearchChange}
                    sx={{
                        width: 250,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            transition: "all 0.2s ease-in-out",
                            "&:hover fieldset": { borderColor: "var(--text-primary)" },
                            "&.Mui-focused fieldset": { borderColor: "var(--color-primary)" },
                        },
                        "& .MuiInputBase-input": { color: "var(--text-primary)" },
                        "& .MuiInputLabel-root.Mui-focused": { color: "var(--text-primary)" },
                    }}
                />
            </Box>

            <TableContainer
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "auto",
                    "&::-webkit-scrollbar": {
                        height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                        backgroundColor: "var(--bg-body)",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "var(--border-color)",
                        borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "var(--text-muted)",
                    },
                }}
            >
                <Table
                    sx={{
                        borderCollapse: "collapse",
                    }}
                >
                    <TableHead>
                        <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold", fontSize: "0.75rem", px: 0.5, py: 1 } }}>
                            <TableCell colSpan={2}>Steel grade</TableCell>
                            <TableCell colSpan={12}>Minimum 0.2% proof strength Rp0.2, MPa</TableCell>
                            <TableCell colSpan={12}>Minimum 1.0% proof strength Rp1.0, MPa</TableCell>
                        </TableRow>

                        <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold", fontSize: "0.85rem", px: 0.5, py: 1 } }}>
                            <TableCell>Steel name</TableCell>
                            <TableCell>Steel number</TableCell>
                            {Array.from({ length: 24 }, (_, i) => (
                                <TableCell key={i}>{[50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600][i % 12]}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {paginatedRows.map((row) => (
                            <TableRow key={row.id} sx={{ "& td": { border: "1px solid var(--border-color)", textAlign: "center", whiteSpace: "nowrap", px: 1 } }}>
                                <TableCell>{row.steelName}</TableCell>
                                <TableCell>{row.steelNumber}</TableCell>
                                {row.properties.map((property, propIndex) => (
                                    <TableCell key={`rp02-${propIndex}`}>{property.proofStrengthRp02Mpa ?? "-"}</TableCell>
                                ))}
                                {row.properties.map((property, propIndex) => (
                                    <TableCell key={`rp10-${propIndex}`}>{property.proofStrengthRp10Mpa ?? "-"}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
            />
        </Paper>
    );
}